import { useNavigate } from 'react-router-dom';

const SubscriptionCancel = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-orange-50 via-yellow-50 to-pink-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full p-12">
                {/* Cancel Icon */}
                <div className="text-center mb-8">
                    <div className="inline-block p-6 bg-orange-100 rounded-full mb-6">
                        <div className="text-7xl">😔</div>
                    </div>

                    <h1 className="text-4xl font-bold text-gray-800 mb-4">
                        Prenumerata atšaukta
                    </h1>

                    <p className="text-xl text-gray-600">
                        Jūsų mokėjimas nebuvo užbaigtas
                    </p>
                </div>

                {/* Message */}
                <div className="bg-orange-50 rounded-2xl p-6 mb-8">
                    <p className="text-gray-700 text-center">
                        Nieko baisaus! Jūsų sąskaita nebuvo apmokestinta.
                        Galite bet kada grįžti ir pasirinkti planą, kuris jums tinka.
                    </p>
                </div>

                {/* Why Upgrade */}
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-6 mb-8">
                    <h3 className="font-bold text-gray-800 mb-4 text-center">
                        Kodėl verta pagerinti planą?
                    </h3>
                    <div className="space-y-3">
                        <div className="flex items-start gap-3">
                            <span className="text-2xl">🚀</span>
                            <div>
                                <p className="font-bold text-gray-800">Daugiau AI užklausų</p>
                                <p className="text-sm text-gray-600">Nuo 50 iki neriboto kiekio per dieną</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3">
                            <span className="text-2xl">🎯</span>
                            <div>
                                <p className="font-bold text-gray-800">Personalizuoti pratimai</p>
                                <p className="text-sm text-gray-600">Pritaikyti jūsų lygiui ir poreikiams</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3">
                            <span className="text-2xl">🧠</span>
                            <div>
                                <p className="font-bold text-gray-800">Adaptyvūs klausimai</p>
                                <p className="text-sm text-gray-600">Sistema mokosi iš jūsų atsakymų</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3">
                            <span className="text-2xl">⚡</span>
                            <div>
                                <p className="font-bold text-gray-800">Prioritetinė pagalba</p>
                                <p className="text-sm text-gray-600">Greitas atsakymas į klausimus</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 mb-6">
                    <button
                        onClick={() => navigate('/subscription')}
                        className="flex-1 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105"
                    >
                        Bandyti dar kartą 🚀
                    </button>

                    <button
                        onClick={() => navigate('/dashboard')}
                        className="flex-1 py-4 bg-gray-100 text-gray-700 rounded-xl font-bold hover:bg-gray-200 transition"
                    >
                        Grįžti į pradžią
                    </button>
                </div>

                {/* Free Plan Reminder */}
                <div className="text-center p-4 bg-blue-50 rounded-xl">
                    <p className="text-sm text-gray-700">
                        💡 <span className="font-bold">Primename:</span> Galite toliau naudotis nemokamu planu su numatytomis AI užklausomis per dieną!
                    </p>
                </div>

                {/* Support */}
                <div className="mt-8 text-center text-sm text-gray-500">
                    <p>Klausimai? Susisiekite: <a href="mailto:info@korepetitorius.eu" className="text-purple-600 hover:underline">info@korepetitorius.eu</a></p>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionCancel;
